module.exports = __webpack_public_path__ + "img/1920_banner.8c6a5d11.png";